
import React, { useEffect, useState, Fragment, useReducer } from 'react'
import { Button, Row, Col, Container, Form, FormControl, InputGroup, Card} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import buscarReducer, { initialStateDisabled } from './storeBuscar/buscar-reducers'
import { INIT, RESET, SET_DISABLED } from './storeBuscar/types'
import {useFormik} from 'formik'
import { validaNumeros } from '../../common/Formatos'
import { Auth, LoadingComponent } from 'recupero-comunes'
import { limpiarCasos, obtenerConsultaHonorarios } from '../../store/actions/solicitud-honorarios-action'
import { validationSchemas } from '../../common/validation-Schemas-solicitud-honorarios'
import { useLocation, useNavigate } from 'react-router-dom'

const BuscarHonorarios = ({handleSolicitarHono, setSelectedRows}) => {  

    const { rutUsuario, rutOrganizacion } = Auth.currentUser()
    const history = useNavigate()

    const resetValues={mandante:rutOrganizacion, origenHono:'', situacionHono:'', fechaDesde:'', fechaHasta:'', patente:'', siniestro:'', nroSolicitud:''}

    const [loading, setLoading]=useState(false)
    const [myValues, setMyValues]=useState(resetValues)
    const [stateBuscar, dispatchBuscar] = useReducer(buscarReducer, initialStateDisabled)

    const data_solitudHonorarios = useSelector((state) => state.solicitudHonorariosReducer)
    const {cfg_form97, companias, origenes, situaciones} = data_solitudHonorarios

    const [selected, setSelected]=useState('')
    
    const dispatch = useDispatch()
    const { state } = useLocation()
    let querState =state?.queryState && state?.queryState

    const formik = useFormik({
        initialValues: {
          "rutcia": rutOrganizacion,
          "rutusr":'',
          "mandante": '',
          "origenHono": '',
          "situacionHono": '',
          "fechaDesde": '',
          "fechaHasta": '',
          "nroSolicitud":'',
          "siniestro":'',
          "patente": ''         
        },
        validationSchema: validationSchemas(selected),
        onSubmit: (formData) => {
          setLoading(true)
            const dataForm = {
                ...formData
            }
    
            try {            
              let query = Buffer.from(JSON.stringify(dataForm)).toString('base64')
              
              dispatch(limpiarCasos())            
              dispatch(obtenerConsultaHonorarios(query)) 
              .then(()=>setLoading(false))
              localStorage.setItem('filtrosBusquedaSolicitudHonorarios', JSON.stringify(dataForm))

            } catch (error) {
              console.log("Error al obtener consulta de honorarios:", error);
              setLoading(false)
            }            
        }
    })
    const handleLimpliar=()=>{
        setSelected('')
        dispatchBuscar({type:INIT})
        dispatch(limpiarCasos())
        setMyValues(resetValues)
        querState=null
        formik.setErrors({})
        setSelectedRows([])
    }
    const handleRadio=(e)=>{
      dispatchBuscar({ type: SET_DISABLED, payload: { disabled: false, name: 'fechaDesde' } })
      dispatchBuscar({ type: SET_DISABLED, payload: { disabled: false, name: 'fechaHasta' } })

      dispatchBuscar({type:RESET})
      dispatchBuscar({type:SET_DISABLED, payload:{disabled:true, name:e.target.id}})
      setSelected(e.target.id)
      setMyValues(resetValues)
    }
    useEffect(()=>{
      dispatchBuscar({type:INIT})
    },[])
    return (
        <>
        <style type='text/css'>
            {`
                .btn-limpiar {
                  background-color: #F0AD3E;
                  color: #FFFFFF;
                  width: 140px;                
                }
                .btn-limpiar:hover{
                  background-color:#e1b97f;
                  color: #FFFFFF;
               }
                .btn-solictar{
                  background-color: #C14B49;
                  color: #FFFFFF;
                  width: 140px;
                  padding:6px 0px 6px 0px;
                }
                .btn-solictar:hover{
                  background-color: #F6897E;
                  color: #FFFFFF;
                }
                .btn-buscar {
                  background-color: #00aeab;
                  color: #FFFFFF;  
                  width: 140px;
                  padding:6px 0px 6px 0px;
                }
                .btn-buscar:hover{
                  background-color: #87c9dc;
                  color: #FFFFFF;
                }         
            `}
        </style>


      <LoadingComponent show={loading}/>
      <Form onSubmit={formik.handleSubmit}>
          <Container>     
              {cfg_form97? (
                <div >      
                  <Card>
                    <Card.Header as='h6' className="text-center" style={{backgroundColor:"#4F517A", color:"white"}} >{
                        cfg_form97 && `${cfg_form97.cfg_form97['busqueda-solicitud-honorarios-filtros']}
                      `}</Card.Header>
                  </Card>
                    <Row >                 
                        <Col>
                          <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                          {cfg_form97.cfg_form97['busqueda-solicitud-honorarios-filtro-mandante']}
                          </Form.Label>{' '}
                          <br />
                          <Form.Select disabled={!stateBuscar.mandante.disabled}
                              onChange={(e)=>{
                                formik.handleChange(e)
                                setMyValues({...myValues,mandante:e.target.value})
                              }}
                              value={formik.values.mandante=myValues.mandante}
                              name='mandante'
                              error={formik.values.error}
                          >
                          <option value={''}>Seleccione...</option>
                                {companias &&
                                  companias.companias?.map((c) => (
                                    <option key={c.id} value={c.id}>
                                      {c.nombre}
                                    </option>
                                  ))}
                          </Form.Select>
                          {formik.errors.mandante ? (
                            <Form.Text variant='danger' style={{ color: 'red' }}>
                              {formik.errors.mandante}
                            </Form.Text>
                          ) : (
                            ''
                          )}
                        </Col>
                        <Col>
                          <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                          {cfg_form97.cfg_form97['busqueda-solicitud-honorarios-filtro-origen']}
                          </Form.Label>{' '}
                          <br />
                          <Form.Select disabled={!stateBuscar.origenHono.disabled}
                              onChange={(e)=>{
                                formik.handleChange(e)
                                setMyValues({...myValues,origenHono:e.target.value})
                              }}
                              value={formik.values.origenHono=myValues.origenHono}
                              name='origenHono'
                              error={formik.values.error}
                          >
                          <option value={''}>Seleccione...</option>
                                {origenes &&
                                  origenes?.map((c) => (
                                    <option key={c.id} value={c.id}>
                                      {c.nombre}
                                    </option>
                                  ))}
                          </Form.Select>
                          {formik.errors.origenHono ? (
                            <Form.Text variant='danger' style={{ color: 'red' }}>
                              {formik.errors.origenHono}
                            </Form.Text>
                          ) : (
                            ''
                          )}
                        </Col>
                        <Col>
                          <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                          {cfg_form97.cfg_form97['busqueda-solicitud-honorarios-filtro-situacion']}
                          </Form.Label>{' '}
                          <br />
                          <Form.Select disabled={!stateBuscar.situacionHono.disabled}
                              onChange={(e)=>{
                                formik.handleChange(e)
                                setMyValues({...myValues,situacionHono:e.target.value})
                              }}
                              value={formik.values.situacionHono=myValues.situacionHono}
                              name='situacionHono'
                              error={formik.values.error}
                          >
                          <option value={''}>Seleccione...</option>
                                {situaciones &&
                                  situaciones?.map((c) => (
                                    <option key={c.id} value={c.id}>
                                      {c.nombre}
                                    </option>
                                  ))}
                          </Form.Select>
                          {formik.errors.situacionHono ? (
                            <Form.Text variant='danger' style={{ color: 'red' }}>
                              {formik.errors.situacionHono}
                            </Form.Text>
                          ) : (
                            ''
                          )}
                        </Col>
                    </Row>
                    <Row >                 
                    <Col md='3'>
                      <Form.Label className='mb-2 mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                        {cfg_form97.cfg_form97['busqueda-solicitud-honorarios-filtro-fecdesde']}
                      </Form.Label>{' '}
                      <br />                      
                      <Form.Control type='date' disabled={!stateBuscar.fechaDesde.disabled}
                        name='fechaDesde'
                        value={formik.values.fechaDesde = myValues.fechaDesde || ''}
                        onChange={(e)=>{
                            formik.handleChange(e)
                            setMyValues({...myValues, fechaDesde:e.target.value})                            
                          }
                        }
                        ></Form.Control>                    
                    </Col>
                    <Col md='3' >
                      <Form.Label className='mb-2 mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                        {cfg_form97.cfg_form97['busqueda-solicitud-honorarios-filtro-fechasta']}
                      </Form.Label>{' '}
                      <br />
                      <Form.Control type='date' disabled={!stateBuscar.fechaHasta.disabled}
                          name='fechaHasta'
                          value={formik.values.fechaHasta = myValues.fechaHasta || ''}
                          onChange={(e)=>{
                            formik.handleChange(e)
                            setMyValues({...myValues,fechaHasta:e.target.value})                            
                          }
                          }
                      ></Form.Control>
                    </Col>
                    </Row>
                    
                    <hr style={{ color: '#04005D', height: '2px', marginTop:'30px' }}></hr>   
                    <Row > 
                      <Col md='3'>
                        <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '14px' }} >
                          {cfg_form97.cfg_form97['busqueda-solicitud-honorarios-filtro-nrosolicitud']}
                        </Form.Label>{' '}
                        <br />
                        <InputGroup>
                          <InputGroup.Radio aria-label="Radio button for following text input" 
                            name='select' 
                            id='nroSolicitud' 
                            checked={stateBuscar.nroSolicitud.disabled}
                            onChange={e=>handleRadio(e)}
                          />
                          <FormControl aria-label="Text input with radio button" disabled={!stateBuscar.nroSolicitud.disabled}
                            onChange={(e)=>{
                              formik.handleChange(e)                                                    
                              setMyValues({...myValues, nroSolicitud:e.target.value})
                            }}
                            value={formik.values.nroSolicitud = myValues.nroSolicitud}
                            name='nroSolicitud'
                            error={formik.values.error}
                          />
                        </InputGroup>
                        {formik.errors.nroSolicitud ? (
                          <Form.Text variant='danger' style={{ color: 'red' }}>
                            {formik.errors.nroSolicitud}
                          </Form.Text>
                        ) : (
                          ''
                        )}
                      </Col>                
                      <Col md='3'>
                        <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                          {cfg_form97.cfg_form97['busqueda-solicitud-honorarios-filtro-siniestro']}
                        </Form.Label>{' '}
                        <br />
                        <InputGroup>
                          <InputGroup.Radio aria-label="Radio button for following text input" 
                            name='select' 
                            id='siniestro' 
                            onChange={e=>handleRadio(e)} 
                            checked={stateBuscar.siniestro.disabled}
                          />
                          <FormControl aria-label="Text input with radio button" disabled={!stateBuscar.siniestro.disabled}
                            onChange={(e)=>{
                              formik.handleChange(e)                                                    
                              setMyValues({...myValues, siniestro:e.target.value})
                            }}
                            value={formik.values.siniestro = myValues.siniestro}
                            name='siniestro'
                            error={formik.values.error}
                          />
                        </InputGroup>
                        {formik.errors.siniestro ? (
                          <Form.Text variant='danger' style={{ color: 'red' }}>
                            {formik.errors.siniestro}
                          </Form.Text>
                        ) : (
                          ''
                        )}
                      </Col>
                      <Col md='3'>
                        <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                          {cfg_form97.cfg_form97['busqueda-solicitud-honorarios-filtro-placa']}
                        </Form.Label>{' '}
                      <br />
                      <InputGroup>
                        <InputGroup.Radio aria-label="Radio button for following text input" 
                          name='select'
                          id='patente' 
                          checked={stateBuscar.patente.disabled}
                          onChange={e=>handleRadio(e)} 
                        />
                        <FormControl aria-label="Text input with radio button"  disabled={!stateBuscar.patente.disabled}
                            onChange={(e)=>{
                              formik.handleChange(e)
                              setMyValues({...myValues, patente:e.target.value})                              
                            }}
                            value={formik.values.patente = myValues.patente}
                            name='patente'
                            error={formik.values.error}
                        />
                        </InputGroup>
                            {formik.errors.patente ? (
                            <Form.Text variant='danger' style={{ color: 'red' }}>
                              {formik.errors.patente}
                            </Form.Text>
                        ) : (
                          ''
                        )}
                      </Col>
                    </Row>
                    <hr style={{ color: '#04005D', height: '2px', marginTop:'30px' }}></hr>                
                    <Row className='mt-2'>
                            
                      <Col className='d-flex align-items-end justify-content-end m-2'>
                          <Button className='m-2' variant='limpiar' onClick={handleLimpliar}  >
                            {cfg_form97 && cfg_form97.cfg_form97["busqueda-solicitud-honorarios-boton-limpiar"]}
                          </Button>
                          <Button className='m-2' variant='solictar' onClick={handleSolicitarHono}  >
                            {cfg_form97 && cfg_form97.cfg_form97["busqueda-solicitud-honorarios-boton-solicitar"]}
                          </Button>
                          <Button className='m-2' variant='buscar' type='onSubmit' >
                            {cfg_form97 && cfg_form97.cfg_form97["busqueda-solicitud-honorarios-boton-buscar"]}
                          </Button>                                                                      
                        </Col>
                    </Row>
                </div>
              ) : null}               
          </Container>       
     </Form>    
    </>
  )
}
export default BuscarHonorarios
